import localeCurrency from "locale-currency";

export const formatPrice = (price: number, locale = navigator.language) => {
  const getUserCurrency = (): string => {
    const locale = navigator.language;
    return localeCurrency.getCurrency(locale) || "USD";
  };

  let currency = getUserCurrency();

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(price / 100);
};
